import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { Page, PageContextProvider } from "@digital-services/shell";
import {
  Button,
  CenterContent,
  CenteredCard,
  Typography
} from "@digital-services/ui";

// Can be replaced by SignedOutPage from "@digital-services/auth";
// But this is not possible yet because it's not independently exported and instead depends on <Shell> flow
const appName = import.meta.env.VITE_APP_APPLICATION_NAME || "";

export const SignedOutPage: FunctionComponent = () => {
  const { t } = useTranslation(undefined, { keyPrefix: "account.signedout" });

  return (
    <PageContextProvider applicationName={appName}>
      <div className="flex h-screen">
        <CenterContent>
          <CenteredCard>
            <Page title={t("page_title")}>
              <Typography variant="description" className="mt-2 mb-2">
                {t("description")}
              </Typography>
              <Link to="/">
                <Button variant="accent">{t("signin_again")}</Button>
              </Link>
            </Page>
          </CenteredCard>
        </CenterContent>
      </div>
    </PageContextProvider>
  );
};
